function $1({title}) {
    return (
        <header className="text-center py-5 mb-4" style={{backgroundImage: `url("assets/header-gradient.jpg")`}}>
            <div className="container">
                <h1 className="fw-light text-white">{title}</h1>
            </div>
        </header>
    );
}

export default $1;